/* eslint-disable */
export const getWindowPath = () => {
  let pathname = ""
  if (typeof window !== `undefined`) {
    pathname = window.location.pathname
  }
  return pathname
}
